// Kept free of app imports (no `import.meta`, no state) so the Playwright fixture can read the same
// lists the app merges with `?test`, instead of keeping a copy that drifts.

// Merged on every stage when `?test=` is present (AVS-4406: ordinary list members, no bypass).
export const BASE_TEST_DEALER_IDS = ['DEU00100V', 'DEU00100L'] as const;
// Merged only outside prod; covers the brand/market combos visited by the E2E suites (V/ESP stays uncovered).
export const EXTENDED_TEST_DEALER_IDS = [
  'DEU00100A',
  'DEU00100N',
  'FRA00100A',
  'FRA00100N',
  'GBR00100A',
  'GBR00100V',
  'AUT00100A',
  'AUT00100V',
  'CHE00100A',
  'CHE00100N',
  'POL00100A',
  'NLD00100N',
  'ITA00100L',
  'AUT00101V',
  'GBR00101V',
  'AUT00101A',
] as const;
// Positive allowlist for the extended set; anything else (prod, unknown, unset) stays base-only.
const EXTENDED_TEST_DEALER_ID_STAGES: readonly string[] = ['test', 'dev', 'prelive'];

/** The Dealer IDs `?test` merges on a stage; also read by the E2E fixture to predict what the app will accept. */
export function testDealerIdsForStage(stage: string | undefined): readonly string[] {
  return typeof stage === 'string' && EXTENDED_TEST_DEALER_ID_STAGES.includes(stage)
    ? [...BASE_TEST_DEALER_IDS, ...EXTENDED_TEST_DEALER_IDS]
    : BASE_TEST_DEALER_IDS;
}
